export default __webpack_public_path__ + "static/media/space.bdd44530.svg";